module.exports = __webpack_public_path__ + "img/pexels-pavel-danilyuk-7352051.216c413b.jpg";